import type { SandboxDashboardTheme } from '@angular-workspace/feature';

/** MahaAgX brand colours for the shared sandbox usage dashboard. */
export const MAHAAGX_SANDBOX_DASHBOARD_THEME: SandboxDashboardTheme = {
  accent: '#11634f',
  accentContrast: '#ffffff',
  accentSoft: '#eef8f3',
  cpuColor: '#11634f',
  gpuColor: '#0891b2',
  // Lighter tints for the chart bars; the darker colours above stay for numbers (text contrast).
  chartCpuColor: '#34d399',
  chartGpuColor: '#38bdf8',
  textPrimary: '#0f172a',
  textSecondary: '#4b5563',
  // Same as the "Recent Activities" heading (var(--primary-color)).
  headingColor: '#00d084',
  border: '#e3ece8',
  surface: '#ffffff',
  surfaceMuted: '#f7fcfa',
  background: '#ffffff',
  success: '#047857',
  successSoft: '#d1fae5',
  warning: '#b45309',
  warningSoft: '#fef3c7',
  danger: '#b91c1c',
  dangerSoft: '#fee2e2',
  chartGridLine: '#edf3f0',
  // Matches the MahaAgX "Showing / Sort" dropdowns (asset grid, challenges).
  controlBackground: '#f0fdf4',
  controlBorder: '#86efac',
  controlValueText: '#059669',
  controlFocusRing: 'rgba(5, 150, 105, 0.1)',
  // Matches the MahaAgX filter-panel multiselect (chip display).
  filterBorder: '#6b7280',
  chipBackground: '#00d084',
  chipText: '#ffffff',
  // Matches the MahaAgX shared table (dark green header, green outline).
  tableHeaderBackground: '#11634f',
  tableHeaderText: '#ffffff',
  tableBorder: 'rgba(17, 99, 79, 0.5)',
  tableRowDivider: '#e5e7eb',
  // Matches the MahaAgX table paginator (activities page).
  pagerBorder: '#333333',
  pagerActiveBackground: '#00b371',
  radius: '12px',
  fontFamily:
    "'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
};
